import {InjectionToken} from '@angular/core'
import {StocksEmbeddedService} from '@service/stocks/stocks.embedded.service'
import {StocksService} from '@service/stocks/stocks.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `StocksService`.
 *
 * @description
 * Devuelve `StocksEmbeddedService` en modo embebido y `StocksService` en
 * modo standalone. `StocksService` expone el stock disponible por
 * producto y distribuidor, consumido al construir líneas de pedido y al
 * validar disponibilidad.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `StocksService`.
 */
export function providerStocksServiceFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new StocksEmbeddedService()
  }
  return new StocksService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `StocksService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerStocksServiceFactory}.
 */
export const StocksServiceToken = new InjectionToken<StocksService>('StocksService')
